import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebTempTermoExtratoDesligamento } from '../models/WebTempTermoExtratoDesligamento.model';
import { environment } from 'environments/environment';
import { WebTempTermoExtratoContribAutopatrocinio } from '../models/WebTempTermoExtratoContribAutopatrocinio.model';

@Injectable({
  providedIn: 'root'
})
export class WebTempTermoExtratoContribAutopatrocinioService {
  private strAction = 'api/WebTempTermoExtratoDesligamento';

  constructor(private http: HttpClient) {

  }
//http://localhost:40320/api/WebTempTermoExtratoContribAutopatrocinio/GetById/1

  public getById(idTermo: number): Observable<WebTempTermoExtratoContribAutopatrocinio> {
    return this.http.get<WebTempTermoExtratoContribAutopatrocinio>(`${environment.TrustCRMApiHost}api/WebTempTermoExtratoContribAutopatrocinio/GetById/${idTermo}`);
  }

  public getByIdTermoExtratoAutopatrocinio(idTermo: number): Observable<WebTempTermoExtratoDesligamento> {
    return this.http.get<WebTempTermoExtratoDesligamento>(`${environment.TrustCRMApiHost}api/WebTempTermoExtratoContribAutopatrocinio/GetByIdTermoExtratoAutopatrocinio?idTermo=${idTermo}`);
  }

}
